import { createContext, useContext } from 'react';
import { PatternsTheme } from './PatternsTheme';

export const PatternsThemeContext = createContext<PatternsTheme>({
  sizes: {},
  toolbar: {
    button: {},
    item: {},
  },
  radioGroup: {},
  rangePicker: {
    size: 'medium',
    width: '172px',
  },
});

export const PatternsThemeProvider = PatternsThemeContext.Provider;
export const PatternsThemeConsumer = PatternsThemeContext.Consumer;

export function usePatternsTheme() {
  return useContext(PatternsThemeContext);
}
